module.exports = __webpack_public_path__ + "static/img/slogan-xs.3402867.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/slogan-xs.jpg
// module id = UFoo
// module chunks = 18